export default __webpack_public_path__ + "media/color/dtr-f459bfa8.svg";